import { createAction, props } from '@ngrx/store';
import { AnalysisSearchResult } from '../models/analysis-search-result';
import { AnalysisSearchParams } from '../models/analysis-search-params';
import { SystemError } from 'src/app/shared/models/SystemError';
import { AnalysisSearchExportParams } from '../models/search-export/analysis-search-export-params';
import { AnalysisSearchRotationsResult } from '../models/analysis-search-rotations-result';

export enum ActionTypes {
    SEARCH_ANALYSES = '[Analysis Search Page] Search analyses',
    SEARCH_ANALYSES_ROTATIONS = '[Search Analysis For Rotations Page] Search analyses for rotations',
    SEARCH_MEASURES = '[Analysis Search Page] Search measures',
    SEARCH_ANALYSES_SUCCESS = '[Analysis Search API] Analyses searched successfully',
    SEARCH_ANALYSES_ROTATIONS_SUCCESS = '[Analysis Search API] Analyses for rotations searched successfully',
    SEARCH_MEASURES_SUCCESS = '[Analysis Search API] Measures searched successfully',
    SEARCH_ANALYSES_FAIL = '[Analysis Search API] Analyses search failed',
    SEARCH_ANALYSES_ROTATIONS_FAIL = '[Analysis Search API] Analyses for rotations search failed',
    SEARCH_MEASURES_FAIL = '[Analysis Search API] Measures search failed',
    CLEAR_ANALYSIS_SEARCH_RESULTS = '[Analysis Search Page] Clear analysis search results',
    CLEAR_ANALYSIS_SEARCH_ROTATIONS_RESULTS = '[Search Analysis For Rotations Page] Clear analysis search for rotations results',
    LOAD_MME_CONSTRAINTS = '[MME Filters] Load MME constraints',
    LOAD_MME_CONSTRAINTS_SUCCESS = '[Analysis Search API] MME constraints loaded successfully',
    LOAD_MME_CONSTRAINTS_FAIL = '[Analysis Search API] MME constraints load failed',
    EXPORT_TO_EXCEL = '[Analysis Search Page] Exporting search results to Excel',
    EXPORT_TO_EXCEL_SUCCESS = '[Analysis Search Page] Exported search results to Excel successfully',
    EXPORT_TO_EXCEL_FAIL = '[Analysis Search Page] Exporting search results to Excel failed'
}

export const searchAnalyses = createAction(ActionTypes.SEARCH_ANALYSES, props<{ params: AnalysisSearchParams }>());

export const searchAnalysesForRotations = createAction(ActionTypes.SEARCH_ANALYSES_ROTATIONS, props<{ params: AnalysisSearchParams }>());

export const searchMeasures = createAction(ActionTypes.SEARCH_MEASURES, props<{ params: AnalysisSearchParams }>());

export const searchAnalysesSuccess = createAction(ActionTypes.SEARCH_ANALYSES_SUCCESS, props<{ result: AnalysisSearchResult; params: AnalysisSearchParams }>());

export const searchAnalysesForRotationsSuccess = createAction(
    ActionTypes.SEARCH_ANALYSES_ROTATIONS_SUCCESS,
    props<{ result: AnalysisSearchRotationsResult }>()
);

export const searchAnalysesFail = createAction(ActionTypes.SEARCH_ANALYSES_FAIL, props<{ systemError: SystemError }>());

export const searchAnalysesForRotationsFail = createAction(ActionTypes.SEARCH_ANALYSES_ROTATIONS_FAIL, props<{ systemError: SystemError }>());

export const searchMeasuresSuccess = createAction(ActionTypes.SEARCH_MEASURES_SUCCESS, props<{ result: AnalysisSearchResult }>());

export const searchMeasuresFail = createAction(ActionTypes.SEARCH_MEASURES_FAIL, props<{ systemError: SystemError }>());

export const clearAnalysisSearchResults = createAction(ActionTypes.CLEAR_ANALYSIS_SEARCH_RESULTS);

export const clearAnalysisSearchForRotationsState = createAction(ActionTypes.CLEAR_ANALYSIS_SEARCH_ROTATIONS_RESULTS);

export const loadMMEConstraints = createAction(ActionTypes.LOAD_MME_CONSTRAINTS);

export const loadMMEConstraintsSuccess = createAction(ActionTypes.LOAD_MME_CONSTRAINTS_SUCCESS, props<{ constraints: string[] }>());

export const loadMMEConstraintsFail = createAction(ActionTypes.LOAD_MME_CONSTRAINTS_FAIL, props<{ systemError: SystemError }>());

export const exportToExcel = createAction(ActionTypes.EXPORT_TO_EXCEL, props<{ exportParams: AnalysisSearchExportParams }>());

export const exportToExcelSuccess = createAction(ActionTypes.EXPORT_TO_EXCEL_SUCCESS);

export const exportToExcelFail = createAction(ActionTypes.EXPORT_TO_EXCEL_FAIL, props<{ systemError: SystemError }>());
